import { useEffect, useMemo, useState } from 'react'
import { useAppSelector } from '../../store'
import { InAppNotificationType } from 'pure-js/enums/InAppNotificationType'
import type { GameReminderPayload } from 'pure-js/types/InAppNotification'
import { selectInAppNotificationsList } from '../../store/selectors/inAppNotificationsSelectors'
import { isGameReminderInShowWindow, isGameReminderPastStart } from '../utils/gameReminderVisibility'

const TICK_INTERVAL_MS = 30 * 1000

/**
 * Returns in-app notifications to show in the bell list and badge.
 * GAME_REMINDER: shown when within 3 min before start (actionable) or after start (history).
 * Once past start they stay visible as history and are disabled 3 min after start — see isGameReminderDisabled.
 */
export function useVisibleInAppNotifications() {
  const notifications = useAppSelector(selectInAppNotificationsList)
  const [tick, setTick] = useState(0)

  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), TICK_INTERVAL_MS)
    return () => clearInterval(id)
  }, [])

  return useMemo(() => {
    const now = Date.now()
    return notifications.filter((notification) => {
      // Being sent to an activity is followed at once; it is never news to list.
      if (notification.type === InAppNotificationType.SENT_TO_ACTIVITY) return false
      if (notification.type !== InAppNotificationType.GAME_REMINDER) return true
      const payload = notification.payload as GameReminderPayload
      return isGameReminderInShowWindow(payload, now) || isGameReminderPastStart(payload, now)
    })
  }, [notifications, tick])
}
